module.exports = __webpack_public_path__ + "media/src/neighbourhood_map/images/location64x64-e0411aae7ca856a06b89cf61a774420d.png";